/* eslint-disable import/extensions */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import swDev from './swDev';

const normalizeDomain = (domain: string): string => {
  return domain.replace(/^www\./, '');
};

const currentDomain = normalizeDomain(window.location.hostname);

const allowedDomain = 'maisdeliveryapp.com.br';

const allowedPath = '/pwa/';

// Função para redirecionar para o domínio desejado
const redirectToAllowedDomain = (): void => {
  const newURL = `https://${allowedDomain}${allowedPath}`;
  window.location.replace(newURL);
};

const isProduction = process.env.REACT_APP_PRODU === 'true';

// Realiza o redirecionamento se estiver em produção e o domínio for diferente do permitido
if (
  isProduction &&
  currentDomain !== allowedDomain &&
  currentDomain !== '127.0.0.1'
) {
  // redirectToAllowedDomain();
}

ReactDOM.render(<App />, document.getElementById('root'));
swDev();
